<template>
  <div class="wrapper">
    <Topbar />
    <LeftSidebar />

    <div class="content-page">
      <div class="content">
        <b-container fluid>
          <slot />
        </b-container>
      </div>
    </div>
  </div>

  <RightSidebar />
</template>

<script lang="ts">
import { useLayoutStore } from '@/stores/layout'
import { defineComponent, onMounted, ref, watch } from 'vue'
import Topbar from '@/views/components/layouts/partials/topbar.vue'
import LeftSidebar from '@/views/components/layouts/partials/left-sidebar.vue'
import RightSidebar from '@/views/components/layouts/partials/right-sidebar.vue'
import router from '@/router'

export default defineComponent({
  components: { RightSidebar, LeftSidebar, Topbar },
  setup() {
    const html = document.getElementsByTagName('html')[0]
    const layoutStore = useLayoutStore()
    const isMenuCondensed = ref(false)
    const layoutWidth = ref('fluid')

    // Initial configuration for layout settings
    layoutStore.config.layout.mode = 'detached'
    layoutStore.config.topbar.color = 'dark'
    layoutStore.config.menu.color = 'light'
    layoutStore.config.sidenav.user = true

    const setInitialMenuSize = () => {
      if (window.screen.width >= 767 && window.screen.width <= 1028) {
        layoutStore.changeLeftbarSize('condensed')
        isMenuCondensed.value = true
      } else if (window.screen.width > 1028) {
        layoutStore.changeLeftbarSize('fixed')
        isMenuCondensed.value = false
      }
    }

    const activateWidth = (width: string) => {
      if (width === 'boxed') {
        document.body.setAttribute('data-layout-mode', 'boxed')
        layoutStore.changeLeftbarSize('condensed')
        isMenuCondensed.value = true
      } else {
        document.body.removeAttribute('data-layout-mode')
        layoutStore.changeLeftbarSize('fixed')
        isMenuCondensed.value = false
      }
    }

    watch(layoutWidth, (newVal, oldVal) => {
      if (newVal !== oldVal) activateWidth(newVal)
    })

    onMounted(() => {
      html?.removeAttribute('data-layout')
      setInitialMenuSize()
      activateWidth(layoutWidth.value)

      // Mobile detection logic for adjusting sidebar
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(navigator.userAgent)
      ) {
        if (window.screen.width >= 728 && window.screen.width <= 1028) {
          document.body.setAttribute('data-sidenav-size', 'condensed')
        }
        router.afterEach(() => {
          document.body.classList.remove('sidebar-enable')
        })
      }
    })

    const toggleMenu = () => {
      document.body.classList.toggle('sidebar-enable')
    }

    const hideMenu = () => {
      document.body.classList.remove('sidebar-enable')
    }

    const toggleRightSidebar = () => {
      document.body.classList.toggle('right-bar-enabled')
    }

    const hideRightSidebar = () => {
      document.body.classList.remove('right-bar-enabled')
    }

    return {
      isMenuCondensed,
      layoutWidth,
      toggleMenu,
      hideMenu,
      toggleRightSidebar,
      hideRightSidebar,
    }
  },
})
</script>
